import { JSX } from 'preact'
import { WidgetLayout } from '@gsc/types'
import { GeneralLayout } from './GeneralLayout'
import { Overlay } from './Overlay'
import { LayoutProps } from './interfaces'

type Props = Omit<LayoutProps, 'layout'>

export function ModalLayout({ overlay, ...props }: Props): JSX.Element {
  return (
    <Overlay overlay={overlay}>
      <GeneralLayout layout={WidgetLayout.Modal} {...props} />
    </Overlay>
  )
}
